"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BreadcrumbLink = void 0;
var React = _interopRequireWildcard(require("react"));
var _classify = _interopRequireDefault(require("../../../utils/classify"));
var _Link = require("../../Link");
var _BreadcrumbLinkModule = _interopRequireDefault(require("./BreadcrumbLink.module.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const BreadcrumbLink = exports.BreadcrumbLink = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    id,
    className,
    as,
    underline = false,
    isActive,
    onClick,
    href,
    to,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(_Link.Link, _extends({}, props, {
    to: to ?? href,
    "data-testid": "BreadcrumbLink",
    ref: ref,
    as: as || 'subTitleExtraSmall',
    underline: underline,
    disabled: isActive,
    className: (0, _classify.default)(_BreadcrumbLinkModule.default.breadcrumbLink,
    // @ts-ignore - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
    {
      [_BreadcrumbLinkModule.default.active]: isActive ?? window.location.href.includes(to ?? href)
    }, className),
    onClick: e => {
      onClick?.(e, id);
    }
  }));
});
BreadcrumbLink.displayName = 'BreadcrumbLink';